"use client";

import { withShortCode } from "@/utils/shortCode";
import SocialShare from ".";
import { SocialLinkProps } from "./types";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";

type ShortCodeSocialShareProps = {
  title?: string;
  className?: string;
  url?: string;
  shareTitle?: string;
  shareSubject?: string;
  children?: string;
  bgColor: "white" | "putty";
};

const SOCIAL_PLATFORMS = {
  facebook: FacebookShareButton,
  x: TwitterShareButton,
  linkedin: LinkedinShareButton,
  email: EmailShareButton,
} as const;

function ShortCodeSocialShare({
  title,
  className,
  url,
  shareTitle,
  shareSubject,
  bgColor = "white",
  children,
}: ShortCodeSocialShareProps) {
  const socialLinks: SocialLinkProps[] = [];

  if (children) {
    const socialLinkPattern = /\[social-link\s+platform="([^"]+)"\]/g;
    let match;

    while ((match = socialLinkPattern.exec(children)) !== null) {
      const [, platform] = match;

      if (platform in SOCIAL_PLATFORMS) {
        socialLinks.push({
          source: platform,
          icon: platform === "email" ? "mail" : platform,
          sr: `Share on ${platform.charAt(0).toUpperCase() + platform.slice(1)}`,
          component:
            SOCIAL_PLATFORMS[platform as keyof typeof SOCIAL_PLATFORMS],
          url: url ?? "",
          ...(shareTitle && { title: shareTitle }),
          ...(shareSubject && { subject: shareSubject }),
        });
      }
    }
  }

  return (
    <SocialShare
      className={className}
      shortcodeData={{
        title,
        socialLinks,
        bgColor,
      }}
    />
  );
}

export default withShortCode(ShortCodeSocialShare);
